import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'EnumerationEdit',
  data: function data() {
    return {
      title: '',
      form: {
        name: '',
        values: '',
        keys: '',
        id: null,
        remarks: ''
      },
      rules: {
        values: [{
          required: true,
          message: '请输入枚举值',
          trigger: 'blur'
        }],
        keys: [{
          required: true,
          message: '请输入枚举Key',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入枚举名称',
          trigger: 'blur'
        }],
        remarks: [{
          required: true,
          message: '请输入枚举名称',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.name = null;
      this.form.values = null;
      this.form.keys = null;
      this.form.id = null;
      this.form.remarks = null;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.name = data.name;
      this.form.values = data.values;
      this.form.keys = data.keys;
      this.form.id = data.id;
      this.form.remarks = data.remarks;
    },
    updateApi: function updateApi() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.UPDATE_ENUMERATION(_this.form);
            case 1:
              _this.$emit('initTableData');
              _this.$message.success('操作成功');
              _this.handleClose();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    saveApi: function saveApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.SAVE_ENUMERATION(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    save: function save() {
      var _this3 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this3.form.id != null) {
            _this3.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this3.updateApi();
            }).catch(function () {
              _this3.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this3.saveApi();
          }
        } else {
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};